// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.6.8_@swc+helpers@0.5.23__webpack@5.108.4_@swc+core@1.15_b0345aabf8a2fe8f5423f3b3e9febcd5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg7yhRjb__RegistrationForm__styles-module__form___pKFA1QrHakgfcIjK {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.pg7yhRjb__RegistrationForm__styles-module__contactSalesLink___Rb7aGoJsfGE5TObO {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/modules/registrationForm/components/RegistrationForm/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.contactSalesLink {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export var form = `pg7yhRjb__RegistrationForm__styles-module__form___pKFA1QrHakgfcIjK`;
export var contactSalesLink = `pg7yhRjb__RegistrationForm__styles-module__contactSalesLink___Rb7aGoJsfGE5TObO`;
export default ___CSS_LOADER_EXPORT___;
